import { Theme } from '@mui/material/styles';

import defaultTheme from 'src/lib/theme/default';

const getTheme = (): Theme => defaultTheme;

export default getTheme;
